(() => {
  const kinds = /\b(shampoos?|toothpastes?|conditioners?|mouthwash(?:es)?|mousses?|mascaras?)\b/gi;
  const oral = /\b(?:mouth|oral)\s+sprays?\b/gi;
  const hairSpray = /\bhair\s+sprays?\b/gi;
  const hairTreatment = /\bhair\s+treatments?\b/gi;
  function buildQuery(value) {
    const raw = value.trim().replace(/\s+/g, ' ');
    if (!raw || /[:"()]/.test(raw) || /\b(?:AND|OR|NOT)\b/.test(raw)) return raw;
    let result = raw.replace(oral, '(title:"mouth spray" OR title:"mouth spary" OR title:"oral spray")');
    result = result.replace(hairSpray, '((title:hair AND (title:spray OR title:mist)) NOT title:removal)');
    result = result.replace(kinds, (word) => `title:${word.toLowerCase()}`);
    result = result.replace(hairTreatment, '((title:hair OR title:scalp) AND (title:treatment OR title:mask OR title:serum OR title:oil OR title:tonic OR title:lotion OR title:vitamin OR title:booster) NOT title:shampoo NOT title:conditioner NOT title:removal)');
    return result;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { buildQuery };
    return;
  }
  const current = new URL(window.location.href);
  const isSearch = /\/search\/?$/.test(current.pathname);
  const original = current.searchParams.get('nhq');
  const query = current.searchParams.get('q') || '';
  const built = buildQuery(query);
  if (isSearch && query && built !== query) {
    current.searchParams.set('q', built);
    current.searchParams.set('nhq', query);
    current.searchParams.delete('page');
    window.location.replace(current.href);
    return;
  }
  function restoreDisplay() {
    if (!isSearch || !original || buildQuery(original) !== query) return;
    document.querySelectorAll('input[type="search"][name="q"]').forEach((input) => {
      if (input.value === query) input.value = original;
    });
    document.title = document.title.replace(query, original);
    document.querySelectorAll('form').forEach((form) => {
      if (!form.querySelector('input[name="q"]') || form.querySelector('input[name="nhq"]')) return;
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'nhq';
      hidden.value = original;
      form.append(hidden);
    });
    document.querySelectorAll('a[href]').forEach((link) => {
      const destination = new URL(link.href, current);
      if (destination.origin === current.origin && /\/search\/?$/.test(destination.pathname) && destination.searchParams.get('q') === query) {
        destination.searchParams.set('nhq', original);
        link.href = destination.href;
      }
    });
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;
    if (form.querySelector('[aria-selected="true"] a')) return;
    const destination = new URL(form.action, current);
    if (destination.origin !== current.origin || !/\/search\/?$/.test(destination.pathname)) return;
    const raw = input.value.trim().replace(/\s+/g, ' ');
    const precise = buildQuery(raw);
    if (!raw || precise === raw) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const params = new URLSearchParams(new FormData(form));
    params.set('q', precise);
    params.set('nhq', raw);
    params.delete('page');
    for (const name of ['preview_theme_id', 'preview_key']) {
      if (current.searchParams.has(name)) params.set(name, current.searchParams.get(name));
    }
    destination.search = params.toString();
    window.location.assign(destination.href);
  }, true);
  function initializeDisplay() {
    restoreDisplay();
    if (isSearch && original && buildQuery(original) === query) {
      const root = document.getElementById('MainContent');
      if (root) new MutationObserver(restoreDisplay).observe(root, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeDisplay);
  else initializeDisplay();
})();

